<template>
  <div
    class="relative h-full overflow-x-hidden overflow-y-scroll rounded-md bg-white p-6 text-left"
  >
    <h4
      class="sticky top-0 bg-white pb-2 text-2xs font-bold uppercase text-body-color"
    >
      {{ isTypeLabel() }}:
      <span v-if="insight?.is_type == 'reused_email_address'">
        {{ insight?.associated_email_addresses?.length }}
      </span>
      <span v-if="insight?.is_type == 'reused_phone'">
        {{ insight?.associated_phones?.length }}
      </span>
      <span v-if="insight?.is_type == 'reused_contact'">
        {{ insight?.associated_contacts?.length }}
      </span>
      <span v-if="insight?.is_type == 'reused_address'">
        {{ insight?.associated_addresses?.length }}
      </span>
      <span v-if="insight?.is_type == 'associated_digital_activity'">
        {{ insight?.associated_carriers?.length }}
      </span>
      <span v-if="insight?.is_type == 'broker_authority_same_address'">
        {{ deDupedAssociatedAddresses?.length }} ({{
          insight?.associated_carriers?.length
        }}
        Broker Authorities)
      </span>
      <span
        v-if="insight?.is_type == 'only_accessed_from_outside_north_america'"
      >
        {{ insight?.associated_remote_addresses?.length }}
      </span>
      <span v-if="insight?.is_type == 'reused_equipment_scheduled_auto'">
        {{ insight?.associated_carriers?.length }}
      </span>
      <span v-if="insight?.is_type == 'flagged_factor'">
        {{ insight?.associated_carriers?.length }}
      </span>
      <span v-if="insight?.is_type == 'flagged_insurance_agent'">
        {{ insight?.associated_carriers?.length }}
      </span>
      <span v-if="insight?.is_type == 'carrier_identifier_changed'">
        {{ insight?.associated_carriers?.length }}
      </span>
      <span v-if="insight?.is_type == 'fmcsa_phone_number_changed_recently'">
        {{ insight?.associated_phones?.length }}
      </span>
      <span v-if="insight?.is_type == 'fmcsa_email_changed_recently'">
        {{ insight?.associated_email_addresses?.length }}
      </span>
      <span v-if="insight?.is_type == 'reused_equipment_same_license_plate'">
        {{ insight?.associated_vehicles?.length }}
      </span>
      <span v-if="insight?.is_type == 'highly_used_address_area'">
        {{ insight?.associated_addresses?.length }}
      </span>
      <span
        v-if="insight?.is_type == 'user_attempting_to_login_as_wrong_carrier'"
      >
        {{ insight?.associated_carriers?.length }}
      </span>
    </h4>
    <div class="mt-4 flex flex-col gap-4 rounded-md">
      <div
        v-if="
          insight?.is_type !== 'reused_equipment_scheduled_auto' &&
          insight?.is_type !== 'flagged_factor' &&
          insight?.is_type !== 'flagged_insurance_agent' &&
          insight?.is_type !== 'only_accessed_from_outside_north_america'
        "
        class="flex flex-col items-start gap-3 rounded-md border-2 border-yellow-500 bg-yellow-20 px-3 py-2"
      >
        <div class="text-left">
          <h4 class="text-2xs font-bold uppercase text-body-color">
            Current Broker
          </h4>
          <div class="mt-2 flex items-center gap-4">
            <router-link
              :to="{
                name: 'Carrier Brokers Show Page',
                params: { id: $store.state.show.showBroker?.id },
              }"
              target="_blank"
              class="text-base text-yellow-600 underline lg:text-xl"
            >
              {{ $store.state.show.showBroker?.name }}
            </router-link>
            <div
              v-if="insight?.is_type == 'associated_digital_activity'"
              class="flex items-center"
            >
              <custom-badge
                :bg-color-class="
                  ratingBgColorClass(
                    $store.state.show.showBroker?.authority_assessment?.rating
                  )
                "
                color-class="text-white"
                :size="`${screenSize == 'mobile' ? 'md' : 'lg'}`"
                :text="
                  $store.state.show.showBroker?.authority_assessment?.rating
                "
              />
            </div>
          </div>
        </div>
        <div
          v-if="insight?.is_type === 'associated_digital_activity'"
          class="w-full"
        >
          <div
            class="flex w-full flex-col justify-between lg:flex-row lg:gap-6"
          >
            <div>
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">IP Addresses</div>
              </h4>
              <h4
                class="inline-block' -mt-1 rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1 text-2xs text-orange-500"
              >
                {{ getIpAddresses(insight?.common_remote_addresses) }}
              </h4>
            </div>
            <div class="mr-10">
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">Address</div>
              </h4>
              <h4 class="w-30 -mt-1 flex flex-wrap text-2xs text-body-color">
                {{
                  `${$store.state.show.showBroker?.contact_information?.headquarters?.address?.street1},
                                ${$store.state.show.showBroker?.contact_information?.headquarters?.address?.city},
                                ${$store.state.show.showBroker?.contact_information?.headquarters?.address?.state},
                                ${$store.state.show.showBroker?.contact_information?.headquarters?.address?.postal_code}`
                }}
              </h4>
            </div>
            <div>
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">Authority</div>
              </h4>
              <h4 class="-mt-1 text-2xs text-body-color">
                {{
                  getAuthoritiesCurrentCarrier(
                    $store.state.show.showBroker?.authority?.authorities
                  )
                    ? getAuthoritiesCurrentCarrier(
                        $store.state.show.showBroker?.authority?.authorities
                      )
                    : '-'
                }}
              </h4>
            </div>
          </div>
        </div>
        <div
          v-else-if="insight?.is_type == 'broker_authority_same_address'"
          class="flex w-full flex-col justify-between text-left lg:flex-row"
        >
          <div>
            <div
              :class="{
                'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1':
                  insight?.is_type == 'reused_address' ||
                  insight?.is_type == 'highly_used_address_area',
                'border-2 border-transparent':
                  insight?.is_type !== 'reused_address' ||
                  insight?.is_type !== 'highly_used_address_area',
              }"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div
                  v-if="
                    insight?.is_type == 'reused_address' ||
                    insight?.is_type == 'highly_used_address_area'
                  "
                  class="items-center gap-1 text-orange-500"
                >
                  <span
                    :class="{
                      'text-orange-500':
                        insight?.is_type == 'reused_address' ||
                        insight?.is_type == 'highly_used_address_area',
                      'text-gray-over-dark':
                        insight?.is_type !== 'reused_address' ||
                        insight?.is_type !== 'highly_used_address_area',
                    }"
                  >
                    Reused Address
                  </span>
                  <svg
                    class="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  v-else
                  class="pt-1"
                >
                  Address
                </div>
              </h4>
              <div v-if="currentCarrier?.address?.length > 0">
                <div
                  v-for="(addr, indexA) in currentCarrier?.address"
                  :key="`${addr?.id}-${indexA}`"
                  class="text-2xs text-body-color"
                >
                  <div
                    class="mb-2"
                    :class="[
                      addr?.is_same_address == true
                        ? 'rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1 text-orange-500'
                        : '',
                    ]"
                  >
                    <div>{{ addr?.street1 }}</div>
                    <div v-if="addr?.street2">
                      {{ addr?.street2 }}
                    </div>
                    <div>
                      {{ addr?.city }}, {{ addr?.state }}
                      {{ addr?.postal_code }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No address on record</div>
              </div>
            </div>
          </div>
          <div>
            <div
              class="w-full"
              :class="{
                'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1':
                  insight?.is_type == 'reused_phone',
                'border-2 border-transparent':
                  insight?.is_type !== 'reused_phone',
              }"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div
                  v-if="insight?.is_type == 'reused_phone'"
                  class="flex items-center gap-1 text-orange-500"
                >
                  <span
                    :class="{
                      'text-orange-500': insight?.is_type == 'reused_phone',
                      'text-gray-over-dark':
                        insight?.is_type !== 'reused_phone',
                    }"
                  >
                    Reused Phone #
                  </span>
                  <svg
                    class="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  v-else
                  class="pt-1"
                >
                  Phone #
                </div>
              </h4>
              <div
                v-if="currentCarrier?.phone"
                class="text-2xs text-body-color"
                :class="{
                  'text-orange-500': insight?.is_type == 'reused_phone',
                  'text-body-color': insight?.is_type !== 'reused_phone',
                }"
              >
                <div
                  :style="{
                    'position: relative; top: -1.5px;':
                      insight?.is_type == 'reused_phone',
                  }"
                >
                  {{ currentCarrier?.phone }}
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No phone number on record</div>
              </div>
            </div>
          </div>
          <div>
            <div
              :class="{
                'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1':
                  insight?.is_type == 'reused_email_address',
                'border-2 border-transparent':
                  insight?.is_type !== 'reused_email_address',
              }"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div
                  v-if="insight?.is_type == 'reused_email_address'"
                  class="flex items-center gap-1 text-orange-500"
                >
                  <span
                    :class="{
                      'text-orange-500':
                        insight?.is_type == 'reused_email_address',
                      'text-gray-over-dark':
                        insight?.is_type !== 'reused_email_address',
                    }"
                  >
                    Reused Email
                  </span>
                  <svg
                    class="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  v-else
                  class="pt-1"
                >
                  Email
                </div>
              </h4>
              <div
                v-if="currentCarrier?.email"
                class="text-2xs text-body-color"
                :class="{
                  'text-orange-500': insight?.is_type == 'reused_email_address',
                  'text-body-color':
                    insight?.is_type !== 'reused_email_address',
                }"
              >
                <div
                  :style="{
                    'position: relative; top: -1.5px;':
                      insight?.is_type == 'reused_email_address',
                  }"
                >
                  {{ currentCarrier?.email }}
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No email address on record</div>
              </div>
            </div>
          </div>
          <div>
            <div
              :class="{
                'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1':
                  insight?.is_type == 'reused_contact',
                'border-2 border-transparent':
                  insight?.is_type !== 'reused_contact',
              }"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div
                  v-if="insight?.is_type == 'reused_contact'"
                  class="flex items-center gap-1 text-orange-500"
                >
                  <span
                    :class="{
                      'text-orange-500': insight?.is_type == 'reused_contact',
                      'text-gray-over-dark':
                        insight?.is_type !== 'reused_contact',
                    }"
                  >
                    Reused Contact
                  </span>
                  <svg
                    class="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  v-else
                  class="pt-1"
                >
                  Contact
                </div>
              </h4>
              <div
                v-if="currentCarrier?.contact"
                class="text-2xs text-body-color"
                :class="{
                  'text-orange-500': insight?.is_type == 'reused_contact',
                  'text-body-color': insight?.is_type !== 'reused_contact',
                }"
              >
                <div
                  :style="{
                    'position: relative; top: -1.5px;':
                      insight?.is_type == 'reused_contact',
                  }"
                >
                  {{ currentCarrier?.contact }}
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No contact on record</div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="insight?.is_type === 'fmcsa_phone_number_changed_recently'"
          class="flex w-full flex-col gap-2"
        >
          <div
            v-for="associated_phone in insight?.associated_phones"
            :key="associated_phone.id"
            class="flex w-full flex-row gap-24"
          >
            <div
              class="-mt-1 inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1 text-2xs text-orange-500"
            >
              <div class="flex gap-1">
                <h4 class="mb-1 text-2xs font-bold uppercase text-orange-500">
                  new phone
                </h4>
                <svg
                  class="h-4 w-4"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                  style="margin-top: -1px"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </div>
              <h4>
                {{ getPhoneChangedRecently(associated_phone).newPhone }}
              </h4>
            </div>
            <div>
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">first seen</div>
              </h4>
              <h4 class="flex flex-wrap text-2xs text-body-color">
                {{ getPhoneChangedRecently(associated_phone).firstSeen }}
              </h4>
            </div>
            <div class="ml-2">
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">age</div>
              </h4>
              <h4 class="text-2xs text-body-color">
                {{ getPhoneChangedRecently(associated_phone).age }}
              </h4>
            </div>
          </div>
        </div>
        <section
          v-else-if="insight?.is_type === 'fmcsa_email_changed_recently'"
        >
          <div class="n flex w-full flex-row gap-24">
            <div
              class="-mt-1 inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1 text-2xs text-orange-500"
            >
              <div class="flex gap-1">
                <h4 class="mb-1 text-2xs font-bold uppercase text-orange-500">
                  new email
                </h4>
                <svg
                  class="h-4 w-4"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                  style="margin-top: -1px"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </div>
              <h4>
                {{ getEmailChangedRecently(insight).newEmail }}
              </h4>
            </div>
            <div>
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">first seen</div>
              </h4>
              <h4 class="flex flex-wrap text-2xs text-body-color">
                {{ getEmailChangedRecently(insight).firstSeen }}
              </h4>
            </div>
            <div class="ml-2">
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">age</div>
              </h4>
              <h4 class="text-2xs text-body-color">
                {{ getEmailChangedRecently(insight).age }}
              </h4>
            </div>
          </div>
        </section>
        <section
          v-if="insight?.is_type == 'user_attempting_to_login_as_wrong_carrier'"
          class="w-full"
        >
          <div class="n flex w-full flex-row gap-24">
            <div>
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">Phone #</div>
              </h4>
              <h4 class="flex flex-wrap text-2xs text-body-color">
                {{
                  $store.state.carriers.showCarrier?.contact_information
                    ?.dispatch_contact?.phone || '-'
                }}
              </h4>
            </div>
            <div>
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">Email</div>
              </h4>
              <h4 class="flex flex-wrap text-2xs text-body-color">
                {{
                  $store.state.carriers.showCarrier?.contact_information
                    ?.dispatch_contact?.email_address || '-'
                }}
              </h4>
            </div>
            <div class="ml-2">
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">Contact</div>
              </h4>
              <div
                v-if="
                  contactForAssociatedCarrier(
                    $store.state.carriers.showCarrier?.contact_information
                      ?.contacts
                  ) !== false
                "
                class="text-2xs text-body-color"
              >
                <div>
                  {{
                    contactForAssociatedCarrier(
                      $store.state.carriers.showCarrier?.contact_information
                        ?.contacts
                    )
                  }}
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No contact on record</div>
              </div>
            </div>
          </div>
        </section>
        <div
          v-else
          class="flex w-full flex-col justify-between lg:flex-row"
        >
          <div>
            <div
              class="w-full"
              :class="{
                'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1':
                  insight?.is_type == 'reused_address' ||
                  insight?.is_type == 'highly_used_address_area',
                'border-2 border-transparent':
                  insight?.is_type !== 'reused_address' ||
                  insight?.is_type !== 'highly_used_address_area',
              }"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div
                  v-if="
                    insight?.is_type == 'reused_address' ||
                    insight?.is_type == 'highly_used_address_area'
                  "
                  class="flex items-center gap-1 text-orange-500"
                >
                  <span
                    :class="{
                      'text-orange-500':
                        insight?.is_type == 'reused_address' ||
                        insight?.is_type == 'highly_used_address_area',
                      'text-gray-over-dark':
                        insight?.is_type !== 'reused_address' ||
                        insight?.is_type !== 'highly_used_address_area',
                    }"
                  >
                    Reused Address
                  </span>
                  <svg
                    class="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  v-else
                  class="pt-1"
                >
                  Address
                </div>
              </h4>
              <div
                v-if="currentCarrier?.address?.street1"
                class="text-2xs"
                :style="{
                  'position: relative; top: -1.5px;':
                    insight?.is_type == 'reused_address' ||
                    insight?.is_type == 'highly_used_address_area',
                }"
                :class="{
                  'text-orange-500':
                    insight?.is_type == 'reused_address' ||
                    insight?.is_type == 'highly_used_address_area',
                  'text-body-color':
                    insight?.is_type !== 'reused_address' ||
                    insight?.is_type !== 'highly_used_address_area',
                }"
              >
                <div>{{ currentCarrier?.address?.street1 }}</div>
                <div v-if="currentCarrier?.address?.street2">
                  {{ currentCarrier?.address?.street2 }}
                </div>
                <div>
                  {{ currentCarrier?.address?.city }},
                  {{ currentCarrier?.address?.state }}
                  {{ currentCarrier?.address?.postal_code }}
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No address on record</div>
              </div>
            </div>
          </div>
          <div>
            <div
              class="w-full"
              :class="[
                insight?.is_type === 'reused_phone'
                  ? 'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1'
                  : 'border-2 border-transparent',
              ]"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div
                  v-if="insight?.is_type === 'reused_phone'"
                  class="flex items-center gap-1 text-orange-500"
                >
                  <span
                    :class="{
                      'text-orange-500': insight?.is_type === 'reused_phone',
                      'text-gray-over-dark':
                        insight?.is_type !== 'reused_phone',
                    }"
                  >
                    Reused Phone #
                  </span>
                  <svg
                    class="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  v-else
                  class="pt-1"
                >
                  Phone #
                </div>
              </h4>
              <div
                v-if="currentCarrier?.phone"
                class="text-2xs text-body-color"
                :class="{
                  'text-orange-500': insight?.is_type == 'reused_phone',
                  'text-body-color': insight?.is_type !== 'reused_phone',
                }"
              >
                <div
                  :style="{
                    'position: relative; top: -1.5px;':
                      insight?.is_type == 'reused_phone',
                  }"
                >
                  {{ currentCarrier?.phone }}
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No phone number on record</div>
              </div>
            </div>
          </div>
          <div>
            <div
              class="w-full"
              :class="[
                insight?.is_type === 'reused_email_address'
                  ? 'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1'
                  : 'border-2 border-transparent',
              ]"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div
                  v-if="insight?.is_type == 'reused_email_address'"
                  class="flex items-center gap-1 text-orange-500"
                >
                  <span
                    :class="{
                      'text-orange-500':
                        insight?.is_type == 'reused_email_address',
                      'text-gray-over-dark':
                        insight?.is_type !== 'reused_email_address',
                    }"
                  >
                    Reused Email
                  </span>
                  <svg
                    class="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  v-else
                  class="pt-1"
                >
                  Email
                </div>
              </h4>
              <div
                v-if="currentCarrier?.email"
                class="text-2xs text-body-color"
                :class="{
                  'text-orange-500': insight?.is_type == 'reused_email_address',
                  'text-body-color':
                    insight?.is_type !== 'reused_email_address',
                }"
              >
                <div
                  :style="{
                    'position: relative; top: -1.5px;':
                      insight?.is_type == 'reused_email_address',
                  }"
                >
                  {{ currentCarrier?.email }}
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No email address on record</div>
              </div>
            </div>
          </div>
          <div>
            <div
              class="w-full"
              :class="{
                'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1':
                  insight?.is_type == 'reused_contact',
                'border-2 border-transparent':
                  insight?.is_type !== 'reused_contact',
              }"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div
                  v-if="insight?.is_type == 'reused_contact'"
                  class="flex items-center gap-1 text-orange-500"
                >
                  <span
                    :class="{
                      'text-orange-500': insight?.is_type == 'reused_contact',
                      'text-gray-over-dark':
                        insight?.is_type !== 'reused_contact',
                    }"
                  >
                    Reused Contact
                  </span>
                  <svg
                    class="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  v-else
                  class="pt-1"
                >
                  Contact
                </div>
              </h4>
              <div
                v-if="currentCarrier?.contact"
                class="text-2xs text-body-color"
                :class="{
                  'text-orange-500': insight?.is_type == 'reused_contact',
                  'text-body-color': insight?.is_type !== 'reused_contact',
                }"
              >
                <div
                  :style="{
                    'position: relative; top: -1.5px;':
                      insight?.is_type == 'reused_contact',
                  }"
                >
                  {{ currentCarrier?.contact }}
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No contact on record</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4 flex flex-col gap-4 rounded-md">
      <div
        v-for="(item, index) in insight[associatedItems]"
        :key="`${item?.id}-${index}`"
        class="flex flex-col items-start gap-3 rounded-md border border-gray-over-dark px-3 py-2"
      >
        <div>
          <div class="mt-2 flex items-center gap-4">
            <router-link
              :to="{
                name: 'Carrier Brokers Show Page',
                params: { id: getCarrierId(item?.carrier_id, item?.id) },
              }"
              target="_blank"
              class="text-base text-yellow-600 underline lg:text-xl"
            >
              {{
                getAssociatedCarrierData(
                  'legal_name',
                  getCarrierId(item?.carrier_id, item?.id)
                )
              }}
            </router-link>
            <div class="flex items-center">
              <custom-badge
                :bg-color-class="
                  ratingBgColorClass(
                    getAssociatedCarrierData(
                      'assessment_rating',
                      getCarrierId(item?.carrier_id, item?.id)
                    )
                  )
                "
                color-class="text-white"
                :size="`${screenSize == 'mobile' ? 'md' : 'lg'}`"
                :text="
                  getAssociatedCarrierData(
                    'assessment_rating',
                    getCarrierId(item?.carrier_id, item?.id)
                  )
                "
              />
            </div>
          </div>
        </div>
        <div
          v-if="insight?.is_type !== 'reused_equipment_same_license_plate'"
          class="flex w-full flex-col justify-between gap-2 lg:flex-row"
        >
          <div>
            <div
              class="w-full"
              :class="{
                'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1':
                  insight?.is_type == 'reused_address' ||
                  insight?.is_type == 'highly_used_address_area',
                'border-2 border-transparent':
                  insight?.is_type !== 'reused_address' ||
                  insight?.is_type !== 'highly_used_address_area',
              }"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div
                  v-if="
                    insight?.is_type == 'reused_address' ||
                    insight?.is_type == 'highly_used_address_area'
                  "
                  class="flex items-center gap-1 text-orange-500"
                >
                  <span
                    :class="{
                      'text-orange-500':
                        insight?.is_type == 'reused_address' ||
                        insight?.is_type == 'highly_used_address_area',
                      'text-gray-over-dark':
                        insight?.is_type !== 'reused_address' ||
                        insight?.is_type !== 'highly_used_address_area',
                    }"
                  >
                    Reused Address
                  </span>
                  <svg
                    class="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  v-else
                  class="pt-1"
                >
                  Address
                </div>
              </h4>
              <div
                v-if="
                  insight?.is_type == 'reused_address' ||
                  insight?.is_type == 'highly_used_address_area'
                "
                class="text-2xs text-body-color"
                :style="{
                  'position: relative; top: -1.5px;':
                    insight?.is_type == 'reused_address' ||
                    insight?.is_type == 'highly_used_address_area',
                }"
                :class="{
                  'text-orange-500':
                    insight?.is_type == 'reused_address' ||
                    insight?.is_type == 'highly_used_address_area',
                  'text-body-color':
                    insight?.is_type !== 'reused_address' ||
                    insight?.is_type !== 'highly_used_address_area',
                }"
              >
                <div
                  class="mb-1 inline-block rounded-full bg-orange-500 px-1 uppercase text-white"
                  style="
                    font-size: 7px;
                    line-height: 7px;
                    padding-top: 3px;
                    padding-bottom: 2px;
                  "
                >
                  {{ capitalizeWords(item?.is_type) }} Address
                </div>
                <div class="pl-1">
                  <div>{{ item?.street1 }}</div>
                  <div v-if="item?.street2">
                    {{ item?.street2 }}
                  </div>
                  <div>
                    {{ item?.city }}, {{ item?.state }} {{ item?.postal_code }}
                  </div>
                </div>
              </div>

              <div
                v-else-if="
                  insight?.is_type == 'broker_authority_same_address' &&
                  getAddressByCarrierId(item, insight.associated_addresses)
                    ?.length > 0
                "
                class="text-2xs text-body-color"
                :style="{
                  'position: relative; top: -1.5px;':
                    insight?.is_type == 'reused_address' ||
                    insight?.is_type == 'highly_used_address_area',
                }"
                :class="{
                  'text-dark-gray':
                    insight?.is_type == 'reused_address' ||
                    insight?.is_type == 'highly_used_address_area',
                  'text-body-color':
                    insight?.is_type !== 'reused_address' ||
                    insight?.is_type !== 'highly_used_address_area',
                }"
              >
                <div
                  v-for="(addr, indexA) in getAddressByCarrierId(
                    item,
                    insight.associated_addresses
                  )"
                  :key="`${addr?.id}-${indexA}`"
                >
                  <div
                    class="mb-2"
                    :class="[
                      insight?.associated_addresses
                        ?.map((obj) => obj?.id)
                        ?.includes(addr?.id)
                        ? 'rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1 text-orange-500'
                        : '',
                    ]"
                  >
                    <div>{{ addr?.street1 }}</div>
                    <div v-if="addr?.street2">
                      {{ addr?.street2 }}
                    </div>
                    <div>
                      {{ addr?.city }}, {{ addr?.state }}
                      {{ addr?.postal_code }}
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-else-if="
                  getAssociatedCarrierData(
                    'physical_addresses',
                    getCarrierId(item?.carrier_id, item?.id)
                  )?.length > 0
                "
                class="text-2xs text-body-color"
                :style="{
                  'position: relative; top: -1.5px;':
                    insight?.is_type == 'reused_address' ||
                    insight?.is_type == 'highly_used_address_area',
                }"
                :class="{
                  'text-dark-gray':
                    insight?.is_type == 'reused_address' ||
                    insight?.is_type == 'highly_used_address_area',
                  'text-body-color':
                    insight?.is_type !== 'reused_address' ||
                    insight?.is_type !== 'highly_used_address_area',
                }"
              >
                <div
                  v-for="(addr, indexA) in getAssociatedCarrierData(
                    'physical_addresses',
                    getCarrierId(item?.carrier_id, item?.id)
                  )"
                  :key="`${addr?.id}-${indexA}`"
                >
                  <div>{{ addr?.street1 }}</div>
                  <div v-if="addr?.street2">
                    {{ addr?.street2 }}
                  </div>
                  <div>
                    {{ addr?.city }}, {{ addr?.state }} {{ addr?.postal_code }}
                  </div>
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No address on record</div>
              </div>
            </div>
          </div>
          <div>
            <div
              class="w-full"
              :class="{
                'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1':
                  insight?.is_type == 'reused_phone',
                'border-2 border-transparent':
                  insight?.is_type !== 'reused_phone',
              }"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div
                  v-if="insight?.is_type == 'reused_phone'"
                  class="flex items-center gap-1 text-orange-500"
                >
                  <span
                    :class="{
                      'text-orange-500': insight?.is_type == 'reused_phone',
                      'text-gray-over-dark':
                        insight?.is_type !== 'reused_phone',
                    }"
                  >
                    Reused Phone #
                  </span>
                  <svg
                    class="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  v-else
                  class="pt-1"
                >
                  Phone #
                </div>
              </h4>
              <div
                v-if="
                  phoneForAssociatedCarrier(
                    getAssociatedCarrierData(
                      'phones',
                      getCarrierId(item.carrier_id, item.id)
                    )
                  ) !== false
                "
                class="text-2xs text-body-color"
                :class="{
                  'text-orange-500': insight?.is_type == 'reused_phone',
                  'text-body-color': insight?.is_type !== 'reused_phone',
                }"
              >
                <div
                  :style="{
                    'position: relative; top: -1.5px;':
                      insight?.is_type == 'reused_phone',
                  }"
                >
                  {{
                    phoneForAssociatedCarrier(
                      getAssociatedCarrierData(
                        'phones',
                        getCarrierId(item.carrier_id, item.id)
                      )
                    )
                  }}
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No phone number on record</div>
              </div>
            </div>
          </div>
          <div>
            <div
              class="w-full"
              :class="{
                'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1':
                  insight?.is_type == 'reused_email_address',
                'border-2 border-transparent':
                  insight?.is_type !== 'reused_email_address',
              }"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div
                  v-if="insight?.is_type == 'reused_email_address'"
                  class="flex items-center gap-1 text-orange-500"
                >
                  <span
                    :class="{
                      'text-orange-500':
                        insight?.is_type == 'reused_email_address',
                      'text-gray-over-dark':
                        insight?.is_type !== 'reused_email_address',
                    }"
                  >
                    Reused Email
                  </span>
                  <svg
                    class="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  v-else
                  class="pt-1"
                >
                  Email
                </div>
              </h4>
              <div
                v-if="
                  emailForAssociatedCarrier(
                    getAssociatedCarrierData(
                      'email_addresses',
                      getCarrierId(item.carrier_id, item.id)
                    )
                  ) !== false
                "
                class="text-2xs text-body-color"
                :class="{
                  'text-orange-500': insight?.is_type == 'reused_email_address',
                  'text-body-color':
                    insight?.is_type !== 'reused_email_address',
                }"
              >
                <div
                  :style="{
                    'position: relative; top: -1.5px;':
                      insight?.is_type == 'reused_email_address',
                  }"
                >
                  {{
                    emailForAssociatedCarrier(
                      getAssociatedCarrierData(
                        'email_addresses',
                        getCarrierId(item.carrier_id, item.id)
                      )
                    )
                  }}
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No email address on record</div>
              </div>
            </div>
          </div>
          <div>
            <div
              class="w-full"
              :class="{
                'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1':
                  insight?.is_type == 'reused_contact',
                'border-2 border-transparent':
                  insight?.is_type !== 'reused_contact',
              }"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div
                  v-if="insight?.is_type == 'reused_contact'"
                  class="flex items-center gap-1 text-orange-500"
                >
                  <span
                    :class="{
                      'text-orange-500': insight?.is_type == 'reused_contact',
                      'text-gray-over-dark':
                        insight?.is_type !== 'reused_contact',
                    }"
                  >
                    Reused Contact
                  </span>
                  <svg
                    class="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  v-else
                  class="pt-1"
                >
                  Contact
                </div>
              </h4>
              <div
                v-if="
                  contactForAssociatedCarrier(
                    getAssociatedCarrierData(
                      'contacts',
                      getCarrierId(item.carrier_id, item.id)
                    )
                  ) !== false
                "
                class="text-2xs text-body-color"
                :class="{
                  'text-orange-500': insight?.is_type == 'reused_contact',
                  'text-body-color': insight?.is_type !== 'reused_contact',
                }"
              >
                <div
                  :style="{
                    'position: relative; top: -1.5px;':
                      insight?.is_type == 'reused_contact',
                  }"
                >
                  {{
                    contactForAssociatedCarrier(
                      getAssociatedCarrierData(
                        'contacts',
                        getCarrierId(item.carrier_id, item.id)
                      )
                    )
                  }}
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No contact on record</div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="flex w-full justify-start gap-8"
        >
          <div>
            <div
              :class="{
                'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1':
                  insight?.is_type == 'reused_address' ||
                  insight?.is_type == 'highly_used_address_area',
                'border-2 border-transparent':
                  insight?.is_type !== 'reused_address' ||
                  insight?.is_type !== 'highly_used_address_area',
              }"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">Type</div>
              </h4>
              <div class="inline-block text-2xs text-body-color">
                <div class="flex flex-col items-start justify-start">
                  <div class="h-8">
                    <svg
                      v-if="item?.is_type == 'power_unit'"
                      class="h-full w-full"
                      viewBox="0 0 33 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.1777 10.5831L10.8322 10.7935V10.7935L10.1777 10.5831ZM15.125 9.62891H15.8125V8.94141H15.125V9.62891ZM15.125 19.2539V19.9414H15.8125V19.2539H15.125ZM2.75 19.2539H2.0625V19.9414H2.75V19.2539ZM4.29688 16.5039V17.1914H4.69896L4.89608 16.841L4.29688 16.5039ZM5.4495 14.4548L4.85029 14.1177L5.4495 14.4548ZM9.15848 13.7539V14.4414H9.65964L9.813 13.9643L9.15848 13.7539ZM11.4867 8.94141C10.5908 8.94141 9.7973 9.51981 9.52314 10.3728L10.8322 10.7935C10.9236 10.5092 11.1881 10.3164 11.4867 10.3164V8.94141ZM15.125 8.94141H11.4867V10.3164H15.125V8.94141ZM15.8125 16.5039V9.62891H14.4375V16.5039H15.8125ZM14.4375 16.5039V19.2539H15.8125V16.5039H14.4375ZM15.125 18.5664H2.75V19.9414H15.125V18.5664ZM3.4375 19.2539V17.8789H2.0625V19.2539H3.4375ZM3.4375 17.8789C3.4375 17.4992 3.7453 17.1914 4.125 17.1914V15.8164C2.98591 15.8164 2.0625 16.7398 2.0625 17.8789H3.4375ZM4.125 17.1914H4.29688V15.8164H4.125V17.1914ZM4.85029 14.1177L3.69767 16.1669L4.89608 16.841L6.04871 14.7919L4.85029 14.1177ZM6.64792 13.0664C5.90279 13.0664 5.2156 13.4683 4.85029 14.1177L6.04871 14.7919C6.17048 14.5754 6.39954 14.4414 6.64792 14.4414V13.0664ZM9.15848 13.0664H6.64792V14.4414H9.15848V13.0664ZM9.52314 10.3728L8.50396 13.5435L9.813 13.9643L10.8322 10.7935L9.52314 10.3728Z"
                        fill="#6D7181"
                      />
                      <path
                        d="M15.125 19.2539H14.4375V19.9414H15.125V19.2539ZM17.875 19.2539V19.9414H18.5625V19.2539H17.875ZM17.875 8.00391L17.2726 7.67259L17.1875 7.82732V8.00391H17.875ZM18.8632 6.20725L19.4656 6.53856L18.8632 6.20725ZM15.8125 8.00391C15.8125 7.00289 16.624 6.19141 17.625 6.19141V4.81641C15.8646 4.81641 14.4375 6.2435 14.4375 8.00391H15.8125ZM15.8125 19.2539V8.00391H14.4375V19.2539H15.8125ZM17.875 18.5664H15.125V19.9414H17.875V18.5664ZM17.1875 8.00391V19.2539H18.5625V8.00391H17.1875ZM18.2608 5.87593L17.2726 7.67259L18.4774 8.33523L19.4656 6.53856L18.2608 5.87593ZM18.4473 6.19141C18.2854 6.19141 18.1827 6.01781 18.2608 5.87593L19.4656 6.53856C19.8915 5.76407 19.3312 4.81641 18.4473 4.81641V6.19141ZM17.625 6.19141H18.4473V4.81641H17.625V6.19141Z"
                        fill="#6D7181"
                      />
                      <circle
                        cx="26.625"
                        cy="22.0039"
                        r="2.75"
                        stroke="#6D7181"
                        stroke-width="1.375"
                      />
                      <circle
                        cx="26.625"
                        cy="22.0039"
                        r="1.375"
                        fill="#6D7181"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2.0625 18.5664H2.75H30.1053H30.5108L30.707 18.9214L31.4669 20.2964L32.2267 21.6714L32.7904 22.6914H31.625H28.7884C28.8449 22.4717 28.875 22.2413 28.875 22.0039C28.875 21.7665 28.8449 21.5361 28.7884 21.3164H30.4596L30.2634 20.9614L29.6997 19.9414H27.944C27.4592 19.5135 26.8224 19.2539 26.125 19.2539C25.4276 19.2539 24.7908 19.5135 24.306 19.9414H22.444C21.9592 19.5135 21.3224 19.2539 20.625 19.2539C19.9276 19.2539 19.2908 19.5135 18.806 19.9414H8.694C8.20923 19.5135 7.57243 19.2539 6.875 19.2539C6.17757 19.2539 5.54077 19.5135 5.056 19.9414H3.4375V21.3164H4.21164C4.15508 21.5361 4.125 21.7665 4.125 22.0039C4.125 22.2413 4.15508 22.4717 4.21164 22.6914H2.75H2.0625V22.0039V19.2539V18.5664ZM9.625 22.0039C9.625 21.7665 9.59492 21.5361 9.53836 21.3164H17.9616C17.9051 21.5361 17.875 21.7665 17.875 22.0039C17.875 22.2413 17.9051 22.4717 17.9616 22.6914H9.53836C9.59492 22.4717 9.625 22.2413 9.625 22.0039ZM23.375 22.0039C23.375 21.7665 23.3449 21.5361 23.2884 21.3164H23.4616C23.4051 21.5361 23.375 21.7665 23.375 22.0039ZM23.375 22.0039C23.375 22.2413 23.4051 22.4717 23.4616 22.6914H23.2884C23.3449 22.4717 23.375 22.2413 23.375 22.0039Z"
                        fill="#6D7181"
                      />
                      <circle
                        cx="20.625"
                        cy="22.0039"
                        r="2.75"
                        stroke="#6D7181"
                        stroke-width="1.375"
                      />
                      <circle
                        cx="20.625"
                        cy="22.0039"
                        r="1.375"
                        fill="#6D7181"
                      />
                      <circle
                        cx="6.625"
                        cy="22.0039"
                        r="2.75"
                        stroke="#6D7181"
                        stroke-width="1.375"
                      />
                      <circle
                        cx="6.625"
                        cy="22.0039"
                        r="1.375"
                        fill="#6D7181"
                      />
                      <path
                        d="M11 19.2539H15.125V23.3789C15.125 24.1383 14.5094 24.7539 13.75 24.7539H12.375C11.6156 24.7539 11 24.1383 11 23.3789V19.2539Z"
                        stroke="#6D7181"
                        stroke-width="1.375"
                      />
                      <path
                        d="M11 22.0039H15.125"
                        stroke="#6D7181"
                        stroke-width="1.375"
                      />
                      <path
                        d="M11.8386 13.0664L12.1136 11.6914H13.0625V13.0664H11.8386Z"
                        fill="#C4C4C4"
                        stroke="#6D7181"
                        stroke-width="1.375"
                      />
                      <path
                        d="M4.125 16.5039H6.7127C7.72367 16.5039 8.72076 16.7393 9.625 17.1914V17.1914"
                        stroke="#6D7181"
                        stroke-width="1.375"
                      />
                    </svg>
                    <svg
                      v-if="item?.is_type == 'trailer'"
                      class="h-full w-full"
                      viewBox="0 0 33 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="19.3334"
                        cy="22.6706"
                        r="2.66667"
                        stroke="#6D7181"
                        stroke-width="1.33333"
                      />
                      <circle
                        cx="19.3335"
                        cy="22.6712"
                        r="1.33333"
                        fill="#6D7181"
                      />
                      <circle
                        cx="25.3334"
                        cy="22.6706"
                        r="2.66667"
                        stroke="#6D7181"
                        stroke-width="1.33333"
                      />
                      <circle
                        cx="25.3335"
                        cy="22.6712"
                        r="1.33333"
                        fill="#6D7181"
                      />
                      <path
                        d="M5.33325 21.3379V24.0046H1.33325"
                        stroke="#6D7181"
                        stroke-width="1.33333"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2 7.33789H2.66667H30.6667H31.3333V8.00456V21.3379V22.0046H30.6667H27.916C27.7812 21.4804 27.491 21.0186 27.0974 20.6712H30V8.67122H3.33333V20.6712H18.2361C17.8425 21.0186 17.5522 21.4804 17.4173 22.0046H2.66667H2V21.3379V8.00456V7.33789ZM23.5693 20.6712C23.1757 21.0186 22.8855 21.4804 22.7507 22.0046H22.5826C22.4477 21.4804 22.1574 21.0186 21.7638 20.6712H23.5693Z"
                        fill="#6D7181"
                      />
                      <path
                        d="M9.33325 21.3379V23.3379H17.3333"
                        stroke="#6D7181"
                        stroke-width="1.33333"
                      />
                    </svg>
                  </div>
                  <div>{{ capitalizeWords(item?.is_type) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div
              :class="{
                'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1':
                  insight?.is_type == 'reused_email_address',
                'border-2 border-transparent':
                  insight?.is_type !== 'reused_email_address',
              }"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div
                  v-if="insight?.is_type == 'reused_email_address'"
                  class="flex items-center gap-1 text-orange-500"
                >
                  <span
                    :class="{
                      'text-orange-500':
                        insight?.is_type == 'reused_email_address',
                      'text-gray-over-dark':
                        insight?.is_type !== 'reused_email_address',
                    }"
                  >
                    Reused Email
                  </span>
                  <svg
                    class="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  v-else
                  class="pt-1"
                >
                  Reg. State
                </div>
              </h4>
              <div
                class="text-2xs text-body-color"
                :class="{
                  'text-dark-gray': insight?.is_type == 'reused_email_address',
                  'text-body-color':
                    insight?.is_type !== 'reused_email_address',
                }"
              >
                <div
                  :style="{
                    'position: relative; top: -1.5px;':
                      insight?.is_type == 'reused_email_address',
                  }"
                >
                  {{ item.license_plate_state }}
                </div>
              </div>
              <!-- <div v-else class="text-2xs text-body-color">
                  <div>No state on record</div>
                </div> -->
            </div>
          </div>
          <div>
            <div
              :class="{
                'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1':
                  insight?.is_type == 'reused_equipment_same_license_plate',
                'border-2 border-transparent':
                  insight?.is_type !== 'reused_equipment_same_license_plate',
              }"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div
                  v-if="
                    insight?.is_type == 'reused_equipment_same_license_plate'
                  "
                  class="flex items-center gap-1 text-orange-500"
                >
                  <span
                    :class="{
                      'text-orange-500':
                        insight?.is_type ==
                        'reused_equipment_same_license_plate',
                      'text-gray-over-dark':
                        insight?.is_type !==
                        'reused_equipment_same_license_plate',
                    }"
                  >
                    Reused VIN
                  </span>
                  <svg
                    class="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  v-else
                  class="pt-1"
                >
                  VIN
                </div>
              </h4>
              <div
                v-if="item.vin"
                class="text-2xs text-body-color"
                :class="{
                  'text-dark-gray':
                    insight?.is_type == 'reused_equipment_same_license_plate',
                  'text-body-color':
                    insight?.is_type !== 'reused_equipment_same_license_plate',
                }"
              >
                <div>{{ item.vin }}</div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No VIN number on record</div>
              </div>
            </div>
          </div>
          <div>
            <div
              :class="{
                'inline-block rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1':
                  insight?.is_type == 'reused_equipment_same_license_plate',
                'border-2 border-transparent':
                  insight?.is_type !== 'reused_equipment_same_license_plate',
              }"
            >
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div
                  v-if="
                    insight?.is_type == 'reused_equipment_same_license_plate'
                  "
                  class="flex items-center gap-1 text-orange-500"
                >
                  <span
                    :class="{
                      'text-orange-500':
                        insight?.is_type ==
                        'reused_equipment_same_license_plate',
                      'text-gray-over-dark':
                        insight?.is_type !==
                        'reused_equipment_same_license_plate',
                    }"
                  >
                    Reused Plate #
                  </span>
                  <svg
                    class="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div
                  v-else
                  class="pt-1"
                >
                  Plate #
                </div>
              </h4>
              <div
                v-if="item.license_plate_number"
                class="text-2xs text-body-color"
                :class="{
                  'text-dark-gray':
                    insight?.is_type == 'reused_equipment_same_license_plate',
                  'text-body-color':
                    insight?.is_type !== 'reused_equipment_same_license_plate',
                }"
              >
                <div
                  :style="{
                    'position: relative; top: -1.5px;':
                      insight?.is_type == 'reused_equipment_same_license_plate',
                  }"
                >
                  {{ item.license_plate_number }}
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No plate number on record</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="insight.is_type === 'associated_digital_activity'">
      <template
        v-for="(carrier, index) in digitalInsights()"
        :key="index"
      >
        <div
          class="mb-3 flex flex-col items-start gap-3 rounded-md border border-gray-over-dark px-3 py-2"
        >
          <div class="mt-2 flex items-center gap-4">
            <router-link
              :to="{
                name: 'Carrier Brokers Show Page',
                params: { id: carrier.id },
              }"
              target="_blank"
              class="text-base text-yellow-600 underline lg:text-xl"
            >
              {{ carrier.legal_name }}
            </router-link>
            <div class="flex items-center">
              <alert-counter
                v-if="!carrier.has_no_published_identity_alerts"
                :alert="carrier?.published_identity_alert_count"
              />
              <custom-badge
                :bg-color-class="ratingBgColorClass(carrier.assessment_rating)"
                color-class="text-white"
                :size="`${screenSize == 'mobile' ? 'md' : 'lg'}`"
                :text="carrier.assessment_rating"
              />
            </div>
          </div>

          <div
            class="flex w-full flex-col justify-between lg:flex-row lg:gap-6"
          >
            <div>
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">IP Addresses</div>
              </h4>
              <h4
                class="inline-block' -mt-1 rounded-md border-2 border-orange-500 bg-orange-150 px-2 py-1 text-2xs text-orange-500"
              >
                {{ getIpAddresses(carrier?.common_remote_addresses) }}
              </h4>
            </div>

            <div class="text-left">
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">address</div>
              </h4>
              <h4
                v-if="carrier.physical_addresses"
                class="w-30 -mt-1 flex flex-wrap text-2xs text-body-color"
              >
                {{
                  `${carrier.physical_addresses[0]?.street1}, ${carrier.physical_addresses[0]?.city},
                              ${carrier.physical_addresses[0]?.state}, ${carrier.physical_addresses[0]?.postal_code}`
                }}
              </h4>
            </div>

            <div>
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">authority</div>
              </h4>
              <h4 class="-mt-1 text-2xs text-body-color">
                {{
                  getCommonAuthority(carrier)
                    ? getCommonAuthority(carrier)
                    : '-'
                }}
              </h4>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div v-if="insight.is_type === 'flagged_factor'">
      <template
        v-for="(carrier, index) in insight.associated_factors"
        :key="index"
      >
        <div
          class="mb-3 flex flex-col items-start gap-3 rounded-md border border-gray-over-dark px-3 py-2"
        >
          <p>{{ carrier.name }}</p>
          <!-- Options and labels -->
          <section class="align-start flex w-full justify-between">
            <div class="w-38 mb-3 mr-4 flex flex-col">
              <label class="text-2xs font-bold uppercase text-gray-over-dark">
                Address
              </label>
              <p class="text-2xs text-dark-gray">
                {{
                  `${carrier.physical_address_street1}, ${carrier.physical_address_city}, ${carrier.physical_address_state}, ${carrier.physical_address_postal_code}`
                }}
              </p>
            </div>
            <div class="w-38 flex flex-col">
              <label class="text-2xs font-bold uppercase text-gray-over-dark">
                phone
              </label>
              <label class="font-dark-gray mt-1 text-2xs">
                {{ carrier?.phone ? carrier.phone : '-' }}
              </label>
            </div>
            <div class="w-38 flex flex-col">
              <label class="text-2xs font-bold uppercase text-gray-over-dark">
                email
              </label>
              <label class="font-dark-gray mt-1 text-2xs">
                {{ carrier?.email_address ? carrier.email_address : '-' }}
              </label>
            </div>
          </section>
        </div>
      </template>
    </div>

    <div v-if="insight?.is_type === 'flagged_insurance_agent'">
      <template
        v-for="(carrier, index) in insight.associated_insurance_producers"
        :key="index"
      >
        <div
          class="mb-3 flex flex-col items-start gap-3 rounded-md border border-gray-over-dark px-3 py-2"
        >
          <p>{{ carrier.name }}</p>
          <section class="align-start flex w-full justify-between">
            <div class="w-38 mb-3 mr-4 flex flex-col">
              <label class="text-2xs font-bold uppercase text-gray-over-dark">
                Address
              </label>
              <p class="text-2xs text-dark-gray">
                {{
                  carrier?.address
                    ? `${carrier.address?.street1} ${carrier.address?.street2}, ${carrier.address?.city}, ${carrier.address?.state}, ${carrier.address?.postal_code}`
                    : '-'
                }}
              </p>
            </div>
            <div class="w-38 flex flex-col">
              <label class="text-2xs font-bold uppercase text-gray-over-dark">
                phone
              </label>
              <label class="font-dark-gray mt-1 text-2xs">
                {{ carrier?.phone ? carrier.phone : '-' }}
              </label>
            </div>
            <div class="w-38 flex flex-col">
              <label class="text-2xs font-bold uppercase text-gray-over-dark">
                email
              </label>
              <label class="font-dark-gray mt-1 text-2xs">
                {{ carrier?.email ? carrier.email : '-' }}
              </label>
            </div>
          </section>
        </div>
      </template>
    </div>

    <div v-if="insight?.is_type === 'only_accessed_from_outside_north_america'">
      <template
        v-for="(carrier, index) in insight.associated_remote_addresses"
        :key="index"
      >
        <div
          class="mb-3 flex flex-col items-start gap-3 rounded-md border border-gray-over-dark px-3 py-2 text-left"
        >
          <p>{{ carrier.name }}</p>
          <section class="w-full">
            <div class="flex flex-col gap-2 lg:grid lg:grid-cols-4 lg:gap-4">
              <div class="mb-3 flex flex-col">
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  city
                </label>
                <p class="text-2xs text-dark-gray">
                  {{ carrier?.city_name ? carrier?.city_name : '-' }}
                </p>
              </div>
              <div class="mb-3 flex flex-col">
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  zip code
                </label>
                <p class="text-2xs text-dark-gray">
                  {{ carrier?.zip_code ? carrier?.zip_code : '-' }}
                </p>
              </div>
              <div class="mb-3 flex flex-col">
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  region
                </label>
                <p class="text-2xs text-dark-gray">
                  {{ carrier?.region_name ? carrier?.region_name : '-' }}
                </p>
              </div>
              <div class="mb-3 flex flex-col">
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  country
                </label>
                <p class="text-2xs text-dark-gray">
                  {{ carrier?.country_name ? carrier?.country_name : '-' }}
                </p>
              </div>
              <div class="flex flex-col">
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  isp
                </label>
                <label class="font-dark-gray mt-1 text-2xs">
                  {{ carrier?.isp ? `${carrier.isp}` : '-' }}
                </label>
              </div>
              <div class="flex flex-col">
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  ip address
                </label>
                <label class="font-dark-gray mt-1 text-2xs">
                  {{ carrier?.ip ? carrier.ip : '-' }}
                </label>
              </div>
            </div>
          </section>
        </div>
      </template>
    </div>

    <div v-if="insight.is_type === 'user_attempting_to_login_as_wrong_carrier'">
      <template
        v-for="(carrier, index) in insight.associated_carriers"
        :key="`user-attempting-${index}`"
      >
        <div
          class="mb-3 flex flex-col items-start gap-3 rounded-md border border-gray-over-dark px-3 py-2"
        >
          <div class="mt-2 flex items-center gap-4">
            <router-link
              :to="{
                name: 'Carrier Brokers Show Page',
                params: { id: carrier.id },
              }"
              target="_blank"
              class="text-base text-yellow-600 underline lg:text-xl"
            >
              {{ carrier.legal_name }}
            </router-link>
            <div class="flex items-center">
              <alert-counter
                v-if="!carrier.has_no_published_identity_alerts"
                :alert="carrier?.published_identity_alert_count"
              />
              <custom-badge
                :bg-color-class="ratingBgColorClass(carrier.assessment_rating)"
                color-class="text-white"
                size="lg"
                :text="carrier.assessment_rating"
              ></custom-badge>
            </div>
          </div>
          <div class="n flex w-full flex-row gap-6">
            <div>
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">Attempted login date</div>
              </h4>
              <h4 class="-mt-1' text-2xs text-body-color">
                {{ formatDate(insight.created_at) || '-' }}
              </h4>
            </div>
            <div>
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">Attempted email used</div>
              </h4>
              <div
                v-if="
                  emailForAssociatedCarrier(
                    getAssociatedCarrierData(
                      'email_addresses',
                      getCarrierId(carrier.carrier_id, carrier.id)
                    )
                  ) !== false
                "
                class="text-2xs text-body-color"
                :class="{
                  'text-orange-500': insight?.is_type == 'reused_email_address',
                  'text-body-color':
                    insight?.is_type !== 'reused_email_address',
                }"
              >
                <div>
                  {{
                    emailForAssociatedCarrier(
                      getAssociatedCarrierData(
                        'email_addresses',
                        getCarrierId(carrier.carrier_id, carrier.id)
                      )
                    )
                  }}
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No email address on record</div>
              </div>
            </div>
            <div>
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">Attempted phone used</div>
              </h4>
              <div
                v-if="
                  phoneForAssociatedCarrier(
                    getAssociatedCarrierData(
                      'phones',
                      getCarrierId(carrier.carrier_id, carrier.id)
                    )
                  ) !== false
                "
                class="text-2xs text-body-color"
                :class="{
                  'text-orange-500': insight?.is_type == 'reused_phone',
                  'text-body-color': insight?.is_type !== 'reused_phone',
                }"
              >
                <div>
                  {{
                    phoneForAssociatedCarrier(
                      getAssociatedCarrierData(
                        'phones',
                        getCarrierId(carrier.carrier_id, carrier.id)
                      )
                    )
                  }}
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No phone number on record</div>
              </div>
            </div>
            <div>
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">contact</div>
              </h4>
              <div
                v-if="
                  contactForAssociatedCarrier(
                    getAssociatedCarrierData(
                      'contacts',
                      getCarrierId(carrier.carrier_id, carrier.id)
                    )
                  ) !== false
                "
                class="text-2xs text-body-color"
              >
                <div>
                  {{
                    contactForAssociatedCarrier(
                      getAssociatedCarrierData(
                        'contacts',
                        getCarrierId(carrier.carrier_id, carrier.id)
                      )
                    )
                  }}
                </div>
              </div>
              <div
                v-else
                class="text-2xs text-body-color"
              >
                <div>No contact on record</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div v-else-if="insight.is_type === 'reused_equipment_scheduled_auto'">
      <template
        v-for="(vehicle, index) in insight.associated_vehicles"
        :key="index"
      >
        <div
          class="mb-3 flex flex-col items-start gap-3 rounded-md border border-gray-over-dark px-3 py-2"
        >
          <label class="text-2xs font-bold uppercase text-body-color">
            associated carrier
          </label>

          <!-- Header line -->
          <div class="flex items-center justify-center">
            <p
              class="mr-3 cursor-pointer text-yellow-600 underline hover:opacity-80"
              @click="onRedirectToCarrierPage(vehicle.carrier_id)"
            >
              {{ selectAssociatedCarrier(vehicle.carrier_id)[0] }}
            </p>
            <custom-badge
              :bg-color-class="
                ratingBgColorClass(
                  selectAssociatedCarrier(vehicle.carrier_id)[1]
                )
              "
              color-class="text-white"
              size="md"
              :text="selectAssociatedCarrier(vehicle.carrier_id)[1]"
            />
          </div>

          <!-- Options and labels -->
          <section class="align-start flex w-full justify-between">
            <div class="flex flex-col">
              <label class="text-2xs font-bold uppercase text-gray-over-dark">
                type
              </label>
              <img
                v-if="vehicle?.is_type == 'power_unit'"
                class="h-10 w-10"
                src="@/assets/power-unit.svg"
                alt="power-unit-icon"
              />
              <img
                v-if="vehicle?.is_type == 'trailer'"
                class="h-10 w-10"
                src="@/assets/trailer.svg"
                alt="trailer-icon"
              />
            </div>
            <div class="flex flex-col">
              <div class="mb-3 flex flex-col">
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  make
                </label>
                <label class="font-dark-gray mt-1 text-2xs">
                  {{ vehicle.make }}
                </label>
                <p class="text-dark-gray"></p>
              </div>
              <div class="flex flex-col">
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  reg. state
                </label>
                <label class="font-dark-gray mt-1 text-2xs">
                  {{
                    vehicle.license_plate_state
                      ? vehicle.license_plate_state
                      : '-'
                  }}
                </label>
              </div>
            </div>
            <div class="flex flex-col">
              <div class="mb-3 flex flex-col">
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  model
                </label>
                <label class="font-dark-gray mt-1 text-2xs">
                  {{ vehicle.model }}
                </label>
              </div>
              <div class="flex flex-col">
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  plate #
                </label>
                <label class="font-dark-gray mt-1 text-2xs">
                  {{
                    vehicle.license_plate_number
                      ? vehicle.license_plate_number
                      : '-'
                  }}
                </label>
              </div>
            </div>
            <div class="flex flex-col">
              <div class="mb-3 flex flex-col">
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  year
                </label>
                <label class="font-dark-gray mt-1 text-2xs">
                  {{ vehicle.model_year }}
                </label>
              </div>
              <div class="flex flex-col">
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  class
                </label>
                <label class="font-dark-gray mt-1 text-2xs">
                  {{
                    vehicle.weight_class?.split(':')[0]
                      ? vehicle.weight_class.split(':')[0]
                      : '-'
                  }}
                </label>
              </div>
            </div>
            <div class="flex flex-col">
              <div class="mb-3 flex flex-col">
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  vin
                </label>
                <label
                  class="mt-1 cursor-pointer text-2xs text-yellow-600 underline hover:opacity-80"
                  @click="onRedirectToVehiclesByVin(vehicle.vin)"
                >
                  {{ vehicle.vin }}
                </label>
              </div>
              <div class="flex flex-col">
                <label class="text-2xs font-bold uppercase text-gray-over-dark">
                  last seen on
                </label>
                <label class="font-dark-gray mt-1 text-2xs">-</label>
              </div>
            </div>
          </section>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { formatPhoneParenthesis } from '@/common/validators.js';
import CustomBadge from '@/components/CustomBadge.vue';
import dayjs from 'dayjs';
import AlertCounter from '@/components/AlertCounter.vue';

export default {
  name: 'ReUsed',
  components: {
    CustomBadge,
    AlertCounter,
  },
  props: {
    insight: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      reusedData: {
        phone: '',
        email: '',
        contact: '',
        address: {
          street1: '',
          street2: '',
          city: '',
          state: '',
          postal_code: '',
        },
      },
      matchingVehicles: [],
      screenSize:
        window.innerWidth <= 640
          ? 'mobile'
          : window.innerWidth <= 1024
            ? 'tablet'
            : 'desktop',
    };
  },
  computed: {
    associatedItems() {
      switch (this.insight?.is_type) {
        case 'reused_email_address':
          return 'associated_email_addresses';
        case 'reused_phone':
          return 'associated_phones';
        case 'reused_contact':
          return 'associated_contacts';
        case 'reused_address':
          return 'associated_addresses';
        case 'carrier_identifier_changed':
          return 'associated_carriers';
        case 'reused_equipment_same_license_plate':
          return 'associated_vehicles';
        case 'reused_equipment_scheduled_auto':
          return 'reused equipment scheduled auto';
        case 'broker_authority_same_address':
          return 'associated_carriers';
        case 'highly_used_address_area':
          return 'associated_addresses';
        default:
          return null;
      }
    },
    associatedCarriers() {
      return this.insight.associated_carriers;
    },

    reusedEmailAddresses() {
      var emails = [];
      if (this.insight?.is_type == 'reused_email_address') {
        this.insight.associated_email_addresses.forEach(function (email) {
          emails.push(email.value);
        });
      } else {
        this.allInsights.forEach(function (item) {
          if (item?.is_type == 'reused_email_address') {
            item.associated_email_addresses.forEach(function (email) {
              emails.push(email.value);
            });
          }
        });
      }
      return emails;
    },
    reusedPhones() {
      var phones = [];
      if (this.insight?.is_type == 'reused_phone') {
        this.insight.associated_phones.forEach(function (phone) {
          phones.push(phone.phone_e164);
        });
      } else {
        this.allInsights.forEach(function (item) {
          if (item?.is_type == 'reused_phone') {
            item.associated_phones.forEach(function (phone) {
              phones.push(phone.phone_e164);
            });
          }
        });
      }
      return phones;
    },
    reusedContacts() {
      var contacts = [];
      if (this.insight?.is_type == 'reused_contact') {
        this.insight.associated_contacts.forEach(function (contact) {
          contacts.push(contact.name);
        });
      } else {
        this.allInsights.forEach(function (item) {
          if (item?.is_type == 'reused_contact') {
            item.associated_contacts.forEach(function (contact) {
              contacts.push(contact.name);
            });
          }
        });
      }
      return contacts;
    },
    reusedAddresses() {
      var addresses = [];
      if (this.insight?.is_type == 'broker_authority_same_address') {
        this.insight.associated_carriers.forEach(function (aCarrier) {
          if (aCarrier?.physical_addresses?.length > 0) {
            aCarrier.physical_addresses.forEach(function (pAddr) {
              addresses.push(
                pAddr?.street1 +
                  ', ' +
                  pAddr?.city +
                  ', ' +
                  pAddr?.state +
                  ' ' +
                  pAddr?.postal_code
              );
            });
          }
          if (aCarrier?.mailing_addresses?.length > 0) {
            aCarrier.mailing_addresses.forEach(function (mAddr) {
              addresses.push(
                mAddr?.street1 +
                  ', ' +
                  mAddr?.city +
                  ', ' +
                  mAddr?.state +
                  ' ' +
                  mAddr?.postal_code
              );
            });
          }
        });
      }
      if (this.insight?.is_type == 'reused_address') {
        this.insight.associated_carriers.forEach(function (aCarrier) {
          addresses.push(
            aCarrier?.street1 +
              ', ' +
              aCarrier?.city +
              ', ' +
              aCarrier?.state +
              ' ' +
              aCarrier?.postal_code
          );
        });
      } else {
        this.allInsights.forEach(function (item) {
          if (item?.is_type == 'reused_address') {
            item.associated_carriers.forEach(function (aCarrier) {
              addresses.push(
                aCarrier?.street1 +
                  ', ' +
                  aCarrier?.city +
                  ', ' +
                  aCarrier?.state +
                  ' ' +
                  aCarrier?.postal_code
              );
            });
          }
        });
      }
      return addresses;
    },
    allInsights() {
      return this.$store.state.show.showBroker?.insights || [];
    },
    currentCarrier() {
      var object;
      if (this.insight?.is_type == 'broker_authority_same_address') {
        object = {
          address: [],
        };
      } else {
        object = {
          address: {},
        };
      }
      var self = this;
      this.$store.state.show.showBroker.contact_information.phones.forEach(
        function (phone) {
          if (self.reusedPhones.includes(phone.phone_e164)) {
            object.phone = phone.value;
            self.reusedData.phone = phone.value;
          }
        }
      );

      if (!object?.phone) {
        this.$store.state.show.showBroker.contact_information.phones.forEach(
          function (phone) {
            if (phone.is_type == 'census_main' && !object?.phone) {
              object.phone = phone.value;
            }
          }
        );
      }

      this.$store.state.show.showBroker.contact_information.email_addresses.forEach(
        function (email) {
          if (self.reusedEmailAddresses.includes(email.value)) {
            object.email = email.value;
            self.reusedData.email = email.value;
          }
        }
      );

      if (!object?.email) {
        this.$store.state.show.showBroker.contact_information.email_addresses.forEach(
          function (email) {
            if (email.is_type == 'census' && !object?.email) {
              object.email = email.value;
            }
          }
        );
      }

      this.$store.state.show.showBroker.contact_information.contacts.forEach(
        function (contact) {
          if (self.reusedContacts.includes(contact.name)) {
            object.contact = contact.name;
            self.reusedData.contact = contact.name;
          }
        }
      );

      if (!object?.contact) {
        this.$store.state.show.showBroker.contact_information.contacts.forEach(
          function (contact) {
            if (contact.is_type == 'census' && !object?.contact) {
              object.contact = contact.value;
            }
          }
        );
      }

      if (this.insight?.is_type == 'broker_authority_same_address') {
        this.$store.state.show.showBroker.contact_information.addresses.forEach(
          function (cAddress) {
            var addr = {
              street1: cAddress?.street1,
              street2: cAddress?.street2,
              city: cAddress?.city,
              state: cAddress?.state,
              postal_code: cAddress?.postal_code,
              is_same_address: false,
            };
            if (
              self.reusedAddresses.includes(
                cAddress?.street1 +
                  ', ' +
                  cAddress?.city +
                  ', ' +
                  cAddress?.state +
                  ' ' +
                  cAddress?.postal_code
              )
            ) {
              addr.is_same_address = true;
            }
            object.address.push(addr);
          }
        );
      } else {
        this.$store.state.show.showBroker.contact_information.addresses.forEach(
          function (cAddress) {
            if (
              self.reusedAddresses.includes(
                cAddress?.street1 +
                  ', ' +
                  cAddress?.city +
                  ', ' +
                  cAddress?.state +
                  ' ' +
                  cAddress?.postal_code
              )
            ) {
              object.address.street1 = cAddress?.street1;
              object.address.street2 = cAddress?.street2;
              object.address.city = cAddress?.city;
              object.address.state = cAddress?.state;
              object.address.postal_code = cAddress?.postal_code;
              self.reusedData.address.street1 = cAddress?.street1;
              self.reusedData.address.street2 = cAddress?.street2;
              self.reusedData.address.city = cAddress?.city;
              self.reusedData.address.state = cAddress?.state;
              self.reusedData.address.postal_code = cAddress?.postal_code;
            } else {
              object.address.street1 =
                self.$store.state.show.showBroker?.contact_information?.headquarters?.address?.street1;
              object.address.street2 =
                self.$store.state.show.showBroker?.contact_information?.headquarters?.address?.street2;
              object.address.city =
                self.$store.state.show.showBroker?.contact_information?.headquarters?.address?.city;
              object.address.state =
                self.$store.state.show.showBroker?.contact_information?.headquarters?.address?.state;
              object.address.postal_code =
                self.$store.state.show.showBroker?.contact_information?.headquarters?.address?.postal_code;
              self.reusedData.address.street1 =
                self.$store.state.show.showBroker?.contact_information?.headquarters?.address?.street1;
              self.reusedData.address.street2 =
                self.$store.state.show.showBroker?.contact_information?.headquarters?.address?.street2;
              self.reusedData.address.city =
                self.$store.state.show.showBroker?.contact_information?.headquarters?.address?.city;
              self.reusedData.address.state =
                self.$store.state.show.showBroker?.contact_information?.headquarters?.address?.state;
              self.reusedData.address.postal_code =
                self.$store.state.show.showBroker?.contact_information?.headquarters?.address?.postal_code;
            }
          }
        );
      }
      return object;
    },
    deDupedAssociatedAddresses: function () {
      if (!this.insight?.associated_addresses) {
        return [];
      }
      let addresses = this.insight.associated_addresses.filter(
        function (item, index, array) {
          return (
            array.findIndex(function (other) {
              return (
                other.street1 === item.street1 &&
                other.street2 === item.street2 &&
                other.city === item.city &&
                other.state === item.state &&
                other.postal_code === item.postal_code
              );
            }) === index
          );
        }
      );
      return addresses;
    },
  },
  mounted() {
    addEventListener('resize', this.resizeListener);
    if (
      this.insight?.is_type == 'reused_equipment_same_license_plate' ||
      this.insight?.is_type === 'associated_digital_activity'
    ) {
      this.getMatchingVehicles(this.insight.associated_vehicles);
    }
  },
  beforeUnmount() {
    removeEventListener('resize', this.resizeListener);
  },
  methods: {
    resizeListener() {
      switch (true) {
        case window.innerWidth <= 640:
          this.screenSize = 'mobile';
          break;
        case window.innerWidth <= 1024:
          this.screenSize = 'tablet';
          break;
        default:
          this.screenSize = 'desktop';
      }
    },
    getPhoneChangedRecently(associatedPhone) {
      // const currentCarrierId = this.$store.state.show.showBroker.id;
      // const associatedPhone = insight.associated_phones.find(function (phone) {
      //   return phone.carrier_id === currentCarrierId;
      // });

      if (!associatedPhone) {
        return {
          newPhone: '-',
          firstSeen: '-',
          age: '-',
        };
      }

      const newPhone = formatPhoneParenthesis(associatedPhone.value) || '-';
      const firstSeen = associatedPhone?.created_at
        ? dayjs(associatedPhone.created_at).format('M/D/YY')
        : '-';
      const age = firstSeen !== '-' ? this.getAge(firstSeen) : '-';

      return {
        newPhone: newPhone,
        firstSeen: firstSeen,
        age: age,
      };
    },
    getEmailChangedRecently(insight) {
      const currentCarrierId = this.$store.state.show.showBroker.id;
      const associatedEmail = insight.associated_email_addresses.find(
        function (email) {
          return email.carrier_id === currentCarrierId;
        }
      );

      if (!associatedEmail) {
        return {
          newEmail: '-',
          firstSeen: '-',
          age: '-',
        };
      }

      const newEmail = associatedEmail.value || '-';
      const firstSeen = associatedEmail?.created_at
        ? dayjs(associatedEmail.created_at).format('M/D/YY')
        : '-';
      const age = firstSeen !== '-' ? this.getAge(firstSeen) : '-';

      return {
        newEmail: newEmail,
        firstSeen: firstSeen,
        age: age,
      };
    },

    getAge(createdAt) {
      if (!createdAt) return;

      const MS_PER_DAY = 1000 * 60 * 60 * 24;
      const createdAtDate = new Date(createdAt);
      const now = new Date();
      const days = Math.floor((now - createdAtDate) / MS_PER_DAY);

      return days === 1 ? '1 day old' : `${days} days old`;
    },
    getIpAddresses(remoteAddresses = []) {
      const ipAddresses = remoteAddresses
        .map((address) => address.ip)
        .join(', ');
      return ipAddresses ? ipAddresses : '-';
    },
    onRedirectToCarrierPage(id) {
      window.open(window.location.origin + '/broker/carriers/' + id, '_blank');
    },
    onRedirectToVehiclesByVin(vin) {
      window.open(
        window.location.origin + '/broker/vehicles/' + vin + '?by_vin=true'
      );
    },
    selectAssociatedCarrier(carrierId) {
      const matched = this.insight.associated_carriers.filter(
        (carrier) => carrier.id === carrierId
      );

      if (matched) {
        return [matched[0].legal_name, matched[0].assessment_rating];
      }
    },
    digitalInsights() {
      let insights = [];
      this.allInsights.forEach((insight) => {
        if (insight.is_type === 'associated_digital_activity') {
          insights = insight.associated_carriers;
        }
      });
      return insights;
    },
    getAuthoritiesCurrentCarrier(carrier) {
      if (carrier.broker_authority_status) {
        return 'Broker';
      }
      if (carrier.common_authority_status) {
        return 'Common';
      }
      if (carrier.contract_authority_status) {
        return 'Contract';
      }
    },
    getCommonAuthority(carrier) {
      if (carrier.is_broker_authority) {
        return 'Broker';
      }
      if (carrier.is_common_authority) {
        return 'Common';
      }
      if (carrier.is_contract_authority) {
        return 'Contract';
      }
    },
    getAssociatedCarrierData(key, carrierId) {
      var returned = '';
      this.insight.associated_carriers.forEach(function (item) {
        if (item.id == carrierId) {
          returned = item[key];
          return returned;
        }
      });
      return returned;
    },

    getAddressByCarrierId(carrier, associatedAddresses = []) {
      if (!carrier) return;

      const associatedIds = new Set(associatedAddresses.map((addr) => addr.id));

      const combinedAddresses = [
        ...(carrier.physical_addresses ?? []),
        ...(carrier.mailing_addresses ?? []),
      ];

      const addressMap = new Map();
      combinedAddresses.forEach((addr) => addressMap.set(addr.id, addr));

      const addresses = Array.from(addressMap.values());

      const matched = addresses.filter((addr) => associatedIds.has(addr.id));

      return matched.length ? matched : addresses.length ? [addresses[0]] : [];
    },
    phoneForAssociatedCarrier(phones) {
      let match = false;
      let census_phone = false;
      let self = this;
      if (phones?.length > 0) {
        phones.forEach(function (phone) {
          if (phone.value == self.currentCarrier?.phone) {
            match = phone.value;
          }
          if (phone.is_type == 'census_main') {
            census_phone = phone.value;
          }
        });
      }
      if (match == false) {
        if (census_phone !== false) {
          match = census_phone;
        }
      }
      return match;
    },
    emailForAssociatedCarrier(emails) {
      let match = false;
      let census = false;
      let self = this;
      if (emails?.length > 0) {
        emails.forEach(function (email) {
          if (email.value == self.currentCarrier?.email) {
            match = email.value;
          }
          if (email.is_type == 'census') {
            census = email.value;
          }
        });
      }
      if (match == false) {
        if (census !== false) {
          match = census;
        }
      }
      return match;
    },
    contactForAssociatedCarrier(contacts) {
      let match = false;
      let census = false;
      let self = this;
      if (contacts?.length > 0) {
        contacts.forEach(function (contact) {
          if (contact.value == self.currentCarrier?.contact) {
            match = contact.name;
          }
          if (contact.is_type == 'census') {
            census = contact.name;
          }
        });
      }
      if (match == false) {
        if (census !== false) {
          match = census;
        }
      }
      return match;
    },
    getCarrierId(id1, id2) {
      if (id1 == undefined) {
        return id2;
      }
      return id1;
    },
    getMatchingVehicles(aVehicles) {
      if (this.insight?.is_type === 'associated_digital_activity') {
        const carrier = this.$store.state.show.showBroker;
        const currentCarrier = [
          {
            rating: carrier?.authority_assessment.rating,
            address: carrier?.contact_information?.headquarters?.address,
            authority: carrier?.authority.authorities,
          },
        ];
        this.matchingVehicles = currentCarrier;
      } else {
        var plates = [];
        this.$store.state.show.showBroker.rows.forEach(function (vehicle) {
          aVehicles.forEach(function (aVehicle) {
            if (
              vehicle.latest_carrier_vehicle.license_plate_number ==
              aVehicle.license_plate_number
            ) {
              if (vehicle.vin == aVehicle.vin) {
                plates.push({
                  id: vehicle.id,
                  is_type: vehicle.is_type,
                  vin: vehicle.vin,
                  reg_state: vehicle.latest_carrier_vehicle.license_plate_state,
                  plate: vehicle.latest_carrier_vehicle.license_plate_number,
                });
              }
            }
          });
        });
        const seen = new Set();
        var filteredPlates = plates.filter((el) => {
          var reused = seen.has(el.id);
          seen.add(el.id);
          return !reused;
        });
        this.matchingVehicles = filteredPlates;
      }
    },
    ratingBgColorClass: function (rating) {
      switch (rating) {
        case 'Not Authorized':
          return 'bg-red-500';
        case 'Review Required':
          return 'bg-orange-500';
        case 'Acceptable':
          return 'bg-green-500';
        case 'Authorized':
          return 'bg-green-500';
        case 'Authorized Carrier':
          return 'bg-green-500';
        case 'Authorized Broker':
          return 'bg-green-500';
        case 'Authorized Broker/Carrier':
          return 'bg-green-500';
        case 'Unrated':
          return 'bg-body-color';
        default:
          return 'bg-body-color';
      }
    },
    iconColorClass: function (rating) {
      switch (rating) {
        case true:
          return 'text-green-500';
        case false:
          return 'text-red-500';
        default:
          return 'text-body-color';
      }
    },
    wrapClass: function (rating) {
      switch (rating) {
        case true:
          return 'border-green-500';
        case false:
          return 'border-red-500';
        default:
          return 'border-light-gray';
      }
    },
    capitalizeWords: function (str) {
      if (str && typeof str === 'string' && str.length > 0) {
        return str
          .replace('_', ' ')
          .toLowerCase()
          .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())
          .replace('Llc', 'LLC')
          .replace('Dba', 'DBA');
      }
    },
    formatDate(date) {
      return dayjs(date).format('M/D/YY');
    },
    isTypeLabel: function () {
      switch (this.insight?.is_type) {
        case 'reused_email_address':
          return 'Email Addresses';
        case 'reused_phone':
          return 'Phone Numbers';
        case 'reused_contact':
          return 'Contacts';
        case 'reused_address':
          return 'Addresses';
        case 'carrier_identifier_changed':
          return 'Carrier Identifiers Matching Another Carrier';
        case 'reused_equipment_same_license_plate':
          return 'Equipment - Same License Plate';
        case 'associated_digital_activity':
          return 'Associated Carriers';
        case 'reused_equipment_scheduled_auto':
          return 'reused equipment on a scheduled auto';
        case 'flagged_factor':
          return 'flagged factor';
        case 'flagged_insurance_agent':
          return 'flagged insurance agent';
        case 'broker_authority_same_address':
          return 'Matching Addresses';
        case 'only_accessed_from_outside_north_america':
          return 'Only Accessed From Outside North America';
        case 'fmcsa_phone_number_changed_recently':
          return 'FMCSA Phone Number Changed Recently';
        case 'fmcsa_email_changed_recently':
          return 'FMCSA Email Changed Recently';
        case 'highly_used_address_area':
          return 'Suspicious Addresses';
        case 'user_attempting_to_login_as_wrong_carrier':
          return 'Access Attempts';
      }
    },
  },
};
</script>
